import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class ActionRatings extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'ActionRatings'
  // Define default properties here
  static instanceDefaults () {
    return {
      rating: null,
      categoryId: null,
      frameworkId: null,
      compassActionId: null,
      standardActionId: null,
      compassId: null,
    }
  }
}
const servicePath = 'action-ratings'
const servicePlugin = makeServicePlugin({
  Model: ActionRatings,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
